import request from './request'
import request1 from './requestPhone'
import requestFile from './requestfile'
import requestForm from './requestForm'

export function ask() {
    return request({
        url: '/xinfang/accessToken.do',
        method: 'get'
    })
}

export function shengji(data) {
    return request({
        url: '/xinfang/area.do',
        method: 'POST',
        data
    })
}

export function phone(data) {
    return request1({
        url: '/sensitive/SendSms.do',
        method: 'POST',
        data
    })
}

export function file(data) {
    return requestFile({
        url: '/xinfang/upload.do',
        method: 'POST',
        data
    })
}

export function saveForm(data) {
    return requestForm({
        url: '/xinfang/submitLetter.do',
        method: 'POST',
        data
    })
}

export function xinfeng(data) {
    return request1({
        url: '/sensitive/SMSverification.do',
        method: 'POST',
        data
    })
}


// WEBPACK FOOTER //
// ./src/unit/api.js